module.exports = __webpack_public_path__ + "img/header-weddingRings@2x.60714b2.jpg";